export const SVG_SPRITE_PATH = "/assets/svg/sprite_v1.svg";

export const IconSprite = ({ tag, ...props }) => (
  <svg {...props}>
    <use
      href={`${SVG_SPRITE_PATH}#${tag}`}
      xlinkHref={`${SVG_SPRITE_PATH}#${tag}`}
    />
  </svg>
);
